import { useMemo } from "react"

import { useTranslation } from "@bounce/i18n"

import type { CityData } from "@/libs/bounce/cities"
import type { PoiData } from "@/libs/bounce/pois"
import { getCityUrlPath, getPoiUrlPath } from "@/libs/router"
import type { Breadcrumb } from "@/types"

type UseListViewBreadcrumbsOptions = { type: "city"; city: CityData } | { type: "poi"; poi: PoiData }

export const useListViewBreadcrumbs = (options: UseListViewBreadcrumbsOptions): Breadcrumb[] => {
  const { t } = useTranslation()

  const breadcrumbs = useMemo(() => {
    const baseBreadcrumbs = [
      {
        id: "bounce",
        name: "Bounce",
        href: "/",
      },
      {
        id: "luggageStorage",
        name: t("page.place.breadcrumbs.luggageStorage", "Luggage Storage"),
        href: "/cities",
      },
    ]

    if (options.type === "city") {
      const { city } = options
      return [
        ...baseBreadcrumbs,
        {
          id: "city",
          name: city.translatedName,
          href: getCityUrlPath({ city, directory: "luggage-storage" }),
        },
      ]
    }
    const { poi } = options
    return [
      ...baseBreadcrumbs,
      {
        id: "city",
        name: poi.city.translatedName,
        href: getCityUrlPath({ city: poi.city, directory: "luggage-storage" }),
      },
      {
        id: "poi",
        name: poi.translatedName,
        href: getPoiUrlPath({ city: poi.city, poi, directory: "luggage-storage" }),
      },
    ]
  }, [t, options])

  return breadcrumbs
}
